module.exports = __webpack_public_path__ + "static/media/LogoTrans.2e953e6f.svg";